// extracted by mini-css-extract-plugin
module.exports = {"copy":"Copy_copy___nLeg"};